import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { loadAreas } from 'redux/modules/areas/effects';
import { getSortedCountriesAndAreas } from 'redux/modules/areas/selectors';
import Select from 'components/Select';
import Input from '@ontruck/ontruck-react-components/lib/Input';
import Checkbox from '@ontruck/ontruck-react-components/lib/Checkbox';
import cx from 'classnames';
import style from './style.module.scss';

const FIELD = {
  areaCountry: 'areaCountry',
  search: 'search',
  open: 'open',
  close: 'close',
  notAdded: 'notAdded',
};

class OutcodesFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: null,
      country: null,
      search: '',
      open: false,
      close: false,
      notAdded: false,
    };
  }

  componentWillMount() {
    const { loadAreas, areas } = this.props;

    return !areas.length ? loadAreas() : false;
  }

  getComputedState(field, value) {
    const state =
      field === 'areaCountry'
        ? this.getAreaCountryValues(value)
        : {
            [field]: value,
          };
    return state;
  }

  // TODO: review this
  fieldHandler = (field) => (value) => {
    this.setState(this.getComputedState(field, value), () => {
      this.props.onChangeHandler(this.state);
    });
  };

  getAreaCountryValues(data) {
    return data
      ? data.values
      : {
          area: null,
          country: null,
        };
  }

  optionRenderer(option) {
    return (
      <div
        className={cx({
          [style.optionCentered]: option.values.area,
        })}
      >
        {option.label}
      </div>
    );
  }

  render() {
    const { areas, intl } = this.props;

    const { search, area, country, open, close, notAdded } = this.state;

    const t = intl.messages.containers.PostalCodes;

    const options = areas.length ? areas : [];

    return (
      <div className={style.container}>
        <div className={style.areaSelect}>
          <Select
            placeholder={t.filters_areas_placeholder}
            onChange={this.fieldHandler(FIELD.areaCountry)}
            options={options}
            value={area || country}
            optionRenderer={this.optionRenderer}
            clearable={false}
          />
        </div>
        <Input
          onChange={this.fieldHandler(FIELD.search)}
          value={search}
          placeholder={t.filters_search_placeholder}
        />
        <Checkbox
          label={t.filters_open}
          onChange={this.fieldHandler(FIELD.open)}
          checked={open}
          boxed
          className={style.statusCheckbox}
        />
        <Checkbox
          label={t.filters_close}
          onChange={this.fieldHandler(FIELD.close)}
          checked={close}
          boxed
          className={style.statusCheckbox}
        />
        <Checkbox
          label={t.filters_no_added}
          onChange={this.fieldHandler(FIELD.notAdded)}
          checked={notAdded}
          boxed
          className={style.statusCheckbox}
        />
      </div>
    );
  }
}

OutcodesFilters.propTypes = {
  areas: PropTypes.any,
  loadAreas: PropTypes.func,
  onChangeHandler: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

const mapStateToProps = (state) => ({
  areas: getSortedCountriesAndAreas(state),
});

const mapDispatchToProps = {
  loadAreas,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(OutcodesFilters));
